import React from "react";
import { LogLoginCard } from "./LogLoginCard";
import { LogLoginUIProvider } from "./LogLoginUIContext";

export function LogLoginPage({ history, match }) {
  const logLoginUIEvents = {};

  return (
    <LogLoginUIProvider logLoginUIEvents={logLoginUIEvents}>
      <LogLoginCard history={history} match={match} />
    </LogLoginUIProvider>
  );
}
